export default class Question {
    constructor() {
        this.init()
    }
    init () {
        $('.question-title').on('click', function () {
            // 为了一点点优化
            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
                    .parent()
                    .children('.question-body').stop().slideUp(300)
            } else {
                // 移除所有激活项 收起内容
                $('.question-item')
                    .children('.question-title').removeClass('active')
                    .end()
                    .children('.question-body').stop().slideUp(300)

                // 激活当前项 展开内容
                $(this).addClass('active')
                    .siblings('.question-body').stop().slideDown(300)
            }
        })
    }
}